import { Box, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import PrimaryButton from "./PrimaryButton";
import { useScroll } from "../context/ScrollContext";
import { useNavigate } from "react-router-dom";

export default function Banner() {
  const { scrollToRef, planesRef } = useScroll();
  const navigate = useNavigate();

  return (
    <Box
      position="relative"
      overflow="hidden"
      display="block"
      alignItems="center"
      justifyContent="center"
      py={{ base: 10, md: "60px" }}
      px={{ base: 6, md: 8, lg: 10, xl: 24 }}
      textAlign="center"
      width={'100%'}
      _before={{
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(135deg, #FFFFFF 0%, #4F86F0 22%, #2E58D9 55%, #1B2FA8 100%)",
        zIndex: 0,
      }}
    >
      {/* Contenido por encima del fondo */}
      <VStack spacing={{ base: 4, md: 4, xl: 8 }} position="relative" zIndex={1} align="center">
        <Heading
          as="h2"
          fontSize={{ base: "3xl", md: "38px", lg: "56px" }}
          fontWeight="medium"
          color="white"
          lineHeight="short"
          data-aos="fade-up"
        >
          <Text as="span">Opera con la certeza de que </Text>
          <Text as="span">tu <Box as="br" display={{ base: "none", xl: "block" }} />situación fiscal está</Text>
          <Text as="span" color={'#1FCDFF'} fontWeight={'bold'}> bajo control</Text>
        </Heading>

        <Flex w="100%" py={{ base: 2, md: 8 }} direction={{ base: "column", xl: "row" }} data-aos="fade-up">
          <Box pt={2} fontSize={{ base: "16px", md: "20px", lg: "22px", xl: "28px" }} textAlign={{ base: "center", xl: "left" }} w={{ base: "100%", xl: "50%" }} borderRight={{ base: "none", xl: "3px solid white" }} borderBottom={{ base: "3px solid white", xl: "none" }} pr={{ base: 0, xl: 8 }} pb={6}>
            <Text color={'white'}><Text fontWeight={'bold'} as={'span'}>SAGA Fiscal</Text> no reemplaza al contador: </Text>
            <Text as="span" color={'white'}>organiza, analiza y da visibilidad para que tu <Box as="br" display={{ base: "none", "2xl": "block" }} />equipo se enfoque en lo que realmente <Box as="br" display={{ base: "none", "2xl": "block" }} />requiere criterio profesional.</Text>
          </Box>
          <Box pt={{ base: 6, md: 2 }} fontSize={{ base: "15px", md: "18px", lg: "20px", xl: "24px" }} textAlign={{ base: "center", xl: "left" }} color={'white'} w={{ base: "100%", xl: "50%" }} pl={{ base: 0, xl: 12 }}>
            Reduce el riesgo fiscal de tu empresa con <Box as="br" display={{ base: "none", xl: "block" }} />información trazable.
          </Box>
        </Flex>

        <Flex
          gap={{ base: 3, md: 16 }}
          pt={{ base: 2, md: 4 }}
          direction={{ base: "column", md: "row" }}
          align="center"
          data-aos="fade-up"
        >
          <PrimaryButton
            bg="white"
            color="blue.500"
            w={{ base: "100%", md: "300px" }}
            borderRadius="full"
            fontWeight="700"
            _hover={{ bg: "white" }}
            onClick={() => navigate("/contactos")}
          >
            Solicitar más información
          </PrimaryButton>

          <PrimaryButton
            bg="#1FCDFF"
            color="gray.600"
            px={"50"}
            w={{ base: "100%", md: "auto" }}
            borderRadius="full"
            fontWeight="700"
            _hover={{ bg: "#1FCDFF" }}
            onClick={() => scrollToRef(planesRef)}
          >
            Comenzar prueba gratuita
          </PrimaryButton>
        </Flex>
      </VStack>
    </Box>
  );
}
